import React, { useEffect } from 'react';

export default function DeleteConfirmModal({ itemLabel, itemType, busy, onCancel, onConfirm }) {
  useEffect(() => {
    const onKeyDown = (event) => event.key === 'Escape' && !busy && onCancel();
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [busy, onCancel]);

  return (
    <div className="admin-confirm" role="dialog" aria-modal="true" aria-labelledby="delete-confirm-title">
      <div className="admin-confirm__backdrop" onClick={!busy ? onCancel : undefined} />
      <div className="admin-confirm__box">
        <div className="admin-confirm__icon" aria-hidden="true">!</div>
        <h2 id="delete-confirm-title">Delete {itemType}?</h2>
        <p>
          You are about to permanently delete <strong title={itemLabel}>{itemLabel}</strong>.
          This action cannot be undone.
        </p>
        <div className="admin-confirm__actions">
          <button type="button" className="admin-btn admin-btn--ghost" onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className="admin-btn admin-btn--danger" onClick={onConfirm} disabled={busy}>
            {busy && <span className="admin-spinner" />}
            {busy ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
